type PalletVixellPlace = 'topBottom' | 'leftRight' | 'frontBack'

export function palletVixellPlace(
  model: string | undefined
): PalletVixellPlace {
  if (model?.includes('TB')) {
    return 'topBottom'
  } else if (model?.includes('FB')) {
    return 'frontBack'
  } else {
    return 'leftRight'
  }
}
